<template>
    <!-- Custom cart icon -->
    <svg :class="size" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 703.5 410.4" xml:space="preserve">
        <path
            d="M190.5,351.8h-58.6c-8.1,0-14.7-6.6-14.7-14.7c0-8.1,6.6-14.7,14.7-14.7h58.6c8.1,0,14.7,6.6,14.7,14.7  C205.2,345.2,198.6,351.8,190.5,351.8z"
        ></path>
        <path
            d="M666.9,351.8h-36.6c-8.1,0-14.7-6.6-14.7-14.7c0-8.1,6.6-14.7,14.7-14.7h24.5l19.8-105.3c-0.3-53.9-46.3-99.9-102.9-99.9  h-96.2l-46.6,205.2H513c8.1,0,14.7,6.6,14.7,14.7c0,8.1-6.6,14.7-14.7,14.7H410.4c-4.5,0-8.7-2-11.5-5.5c-2.8-3.5-3.8-8-2.8-12.4  l53.3-234.5c1.5-6.7,7.4-11.4,14.3-11.4h107.9c72.7,0,131.9,59.2,131.9,131.9l-22.2,120C680,346.7,673.9,351.8,666.9,351.8z"
        ></path>
        <path
            d="M571.6,410.4c-40.4,0-73.3-32.9-73.3-73.3s32.9-73.3,73.3-73.3s73.3,32.9,73.3,73.3S612,410.4,571.6,410.4z M571.6,293.1  c-24.2,0-44,19.7-44,44s19.7,44,44,44c24.2,0,44-19.7,44-44S595.9,293.1,571.6,293.1z"
        ></path>
        <path
            d="M249.2,410.4c-40.4,0-73.3-32.9-73.3-73.3s32.9-73.3,73.3-73.3s73.3,32.9,73.3,73.3S289.6,410.4,249.2,410.4z M249.2,293.1  c-24.2,0-44,19.7-44,44s19.7,44,44,44s44-19.7,44-44S273.4,293.1,249.2,293.1z"
        ></path>
        <path d="M190.5,87.9H73.3c-8.1,0-14.7-6.6-14.7-14.7s6.6-14.7,14.7-14.7h117.3c8.1,0,14.7,6.6,14.7,14.7S198.6,87.9,190.5,87.9z"></path>
        <path
            d="M190.5,175.9H44c-8.1,0-14.7-6.6-14.7-14.7c0-8.1,6.6-14.7,14.7-14.7h146.6c8.1,0,14.7,6.6,14.7,14.7  C205.2,169.3,198.6,175.9,190.5,175.9z"
        ></path>
        <path d="M190.5,263.8H14.7c-8.1,0-14.7-6.6-14.7-14.7s6.6-14.7,14.7-14.7h175.9c8.1,0,14.7,6.6,14.7,14.7S198.6,263.8,190.5,263.8z"></path>
        <path
            d="M410.4,351.8H307.8c-8.1,0-14.7-6.6-14.7-14.7c0-8.1,6.6-14.7,14.7-14.7h90.9l66.6-293.1H131.9c-8.1,0-14.7-6.6-14.7-14.7  S123.8,0,131.9,0h351.8c4.5,0,8.7,2,11.5,5.5c2.8,3.5,3.8,8,2.8,12.4l-73.3,322.4C423.2,347,417.2,351.8,410.4,351.8L410.4,351.8z"
        ></path>
    </svg>
</template>
<script setup lang="ts">
defineProps({
    size: {
        type: String,
        default: 'w-10 h-10',
    },
});
</script>
